<template>
  <div class="keyboard">
    <div class="title" v-html="$t('keyboard.title')"></div>
    <div class="header-panel" v-if="profile.version === 'r2'">
      <a-radio-group v-model="layerIndex" size="large">
        <a-radio-button
          v-for="index in layerNum"
          :key="index"
          :value="index - 1"
        >
          {{ $t("keyboard.layer") + " " + index }}
        </a-radio-button>
      </a-radio-group>
      <i
        class="add iconfont iconplus-o"
        v-if="layerNum < 7"
        @click="onAddLayer"
      />
      <i
        class="remove iconfont iconminus-o"
        v-if="layerIndex > 7"
        @click="onRemoveLayer"
      />
    </div>
    <div class="keyboard-panel">
      <c-keyboard
        class="c-keyboard"
        :keyboardSettings="keyboardSettings"
        :selectedIndex="selectedIndex"
        :layerIndex="layerIndex"
        @key-click="onKeyClick"
      />
    </div>
    <div class="virtual-keyboard-panel">
      <c-virtual-keyboard
        class="c-virtual-keyboard"
        v-if="selectedVirtualKey"
        :selectedKey="selectedVirtualKey"
        :layerNum="layerNum"
        :layerIndex="layerIndex"
        @key-click="onVirtualKeyClick"
      />
    </div>
    <div class="buttons" v-if="!inLoader">
      <div class="button" @click="onBack">
        {{ $t("confirm") }} & {{ $t("back") }}
      </div>
      <c-profile-download
        class="button"
        :profile="data"
        :fileName="profile.fileName"
        :version="profile.version"
        @click="onSave"
        v-if="false"
      >
        <i class="iconfont icondownload" />
        {{ $t("download") }}
      </c-profile-download>
    </div>
    <div class="in-switch-led" @click="goInSwitchLED" v-if="!inLoader">
      <i class="iconfont iconarrow-right" />
      <div v-html="$t('keyboard.inSwitchLED')"></div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deepCopy } from "@/utils";
export default {
  name: "Keyboard",
  data() {
    return {
      layerIndex: 0,
      keyboardSettings: [],
      selectedIndex: -2,
      selectedVirtualKey: null,
      saved: true,
    };
  },
  computed: {
    ...mapState("loader", {
      inLoader: "inLoader",
    }),
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState(["profile"]),
    data() {
      return {
        ...this.profile.data,
        ["keyboardSettings" + (this.layerIndex || "")]: this.keyboardSettings,
      };
    },
    layerNum() {
      let num = 0;
      for (const key in this.profile.data) {
        if (key.includes("keyboardSettings")) {
          num++;
        }
      }
      return num;
    },
  },
  methods: {
    onAddLayer() {
      let data = { ...this.profile.data };
      const key = ["keyboardSettings" + this.layerNum];
      data[key] = data.keyboardSettings;
      this.$store.dispatch("profile/setData", data);
    },
    onRemoveLayer() {
      let data = this.profile.data;
      [
        "keyboardSettings",
        "keyboardSettings1",
        "keyboardSettings2",
        "keyboardSettings3",
        "keyboardSettings4",
        "keyboardSettings5",
        "keyboardSettings6",
      ].map((key) => {
        if (data[key]) {
          data[key].map((item) => {
            if (item.dstKey === "key_cmd_set_key_layer" + this.layerNum) {
              item.dstKey = item.srcKey;
            }
            if (item.dstKey === "key_hold_set_key_layer" + this.layerNum) {
              item.dstKey = item.srcKey;
            }
          });
        }
      });
      if (this.layerIndex === this.layerNum - 1) {
        this.layerIndex -= 1;
      }
      setTimeout(() => {
        const key = ["keyboardSettings" + (this.layerNum - 1)];
        delete data[key];
        this.$store.dispatch("profile/setData", { ...data }).then(() => {
          this.keyboardSettings = deepCopy(
            this.profile.data["keyboardSettings" + (this.layerIndex || "")]
          );
        });
      }, 200);
    },
    onKeyClick({ index, dstKey }) {
      this.selectedVirtualKey = this.selectedIndex === index ? null : dstKey;
      this.selectedIndex = this.selectedIndex === index ? -1 : index;
    },
    onVirtualKeyClick(key) {
      this.selectedVirtualKey = key;
      let newSettings = [...this.keyboardSettings];
      newSettings[this.selectedIndex].dstKey = key;
      this.keyboardSettings = newSettings;
      this.saved = false;
    },
    onBack() {
      this.onSave();
      this.$router.push(this.$paths.index);
    },
    onSave() {
      this.$store
        .dispatch("profile/setData", {
          ...this.profile.data,
          ["keyboardSettings" + (this.layerIndex || "")]: this.keyboardSettings,
        })
        .then(() => {
          this.saved = true;
        });
    },
    goInSwitchLED() {
      this.onSave();
      this.$router.push(this.$paths.inSwitchLED);
    },
  },
  watch: {
    layerIndex(index, oldIndex) {
      this.$store
        .dispatch("profile/setData", {
          ...this.profile.data,
          ["keyboardSettings" + (oldIndex || "")]: this.keyboardSettings,
        })
        .then(() => {
          this.keyboardSettings = deepCopy(
            this.profile.data["keyboardSettings" + (index || "")]
          );

          if (this.selectedVirtualKey) {
            const selectedVirtualKey = this.keyboardSettings[this.selectedIndex]
              .dstKey;
            if (
              ["key_led_cmd_power", "key_led_cmd_factory_reset"].includes(
                selectedVirtualKey
              )
            ) {
              this.selectedIndex = -1;
              this.selectedVirtualKey = null;
            } else {
              this.selectedVirtualKey = selectedVirtualKey;
            }
          }
        });
    },
  },
  mounted() {
    this.keyboardSettings = deepCopy(this.profile.data.keyboardSettings);
  },
};
</script>
<style lang="scss" scoped>
.keyboard {
  text-align: center;
  color: #ffffff;
  padding: 80px 0 400px 0;

  .title {
    font-size: 20px;
    margin-bottom: 30px;
  }

  .header-panel {
    @include flex-center;
    width: 1300px;
    margin: 0 auto 40px auto;
    justify-content: flex-start;
    padding-left: 45px;

    .add,
    .remove {
      @include icon-hover;
      font-size: 30px;
      margin-left: 20px;
    }

    .remove {
      margin-left: 10px;
    }
  }

  .keyboard-panel {
    @include flex-center;
    margin-bottom: 20px;

    .c-keyboard {
      width: 1300px;
    }
  }

  .virtual-keyboard-panel {
    @include flex-center;
    margin-bottom: 60px;

    .c-virtual-keyboard {
      width: 1320px;
    }
  }

  .buttons {
    @include flex-center;

    .button {
      @include button;
      width: 200px;
      margin: 0 50px;

      span {
        font-size: 24px;
        line-height: 12px;
      }
    }
  }

  .in-switch-led {
    @include flex-center;
    position: fixed;
    right: 50px;
    bottom: 200px;
    font-size: 20px;
    cursor: pointer;

    &:hover {
      color: $primary-color;
    }

    i {
      width: 54px;
      height: 54px;
      line-height: 54px;
      display: block;
      background: $primary-color;
      color: #ffffff;
      border-radius: 10px;
      margin-right: 20px;
      font-size: 22px;
      padding-left: 5px;
      text-align: center;
    }
  }
}
</style>
